/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from "antd";
import i18next from "i18next";
import React, { useEffect, useState } from "react";
import ReactFlow, { addEdge, Controls, ReactFlowProvider, removeElements } from "react-flow-renderer";
import styled from 'styled-components';
import { propHasValue } from "../../../../components/DynamicFormNew/helper";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const CircleStyle = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  right: 100%;
  width: 10px;
  height: 10px;
  background: #2E90FA33;
  border: 1px solid var(--mmt-primary-70);
  z-index: 200;
  cursor: pointer;
  font-size: 10px;
  color: #828282;
  border-radius: 2;
  padding-left: 0px;
  border-radius: 100%;
  transition: .4s;

  &.active {
    transform: translate(200%, -50%);
  }

  &.lr {
    left: 100%;
    rigth: 0px;
    transform: translate(-50%, -50%);
  }
`;

const Default = styled.div`
  transition: .4s padding-left;
  max-width: 150px;
  overflow: hidden;

  label {
    max-width: 120px;
    margin-bottom: 0px;
    color: #001529;
    font-size: 14px;
    font-weight: 500;
    margin-top: -3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.active {
    padding-left: 20px;
  }
`;

const OwnDataStyle = styled.div`
  padding: 0px 6px;
  display: flex;
  gap: 6px;
  max-width: 120px;
  overflow: hidden;

  label {
    margin-bottom: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #001529;
    font-size: 14px;
    font-weight: 500;
    margin-top: -3px;
  }

  img {
    width: 21px;
    height: 20px;
    margin-top: -3px;
  }

`;

export function useNodes({
  items,
  type,
  setActiveNode = () => { },
  activeNode = null,
  t = (s) => s,
}) {
  const [X, Y] = type === 'RL' ? [-250, -80] : [250, -80];
  const [relations, setRelations] = useState({});
  const [initElements, setInitElements] = useState();
  const [elements, setElements] = useState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));

  const onConnect = (params) => setElements((els) => addEdge({
    ...params,
    type: 'buttonedge',
  }, els));

  const onLoad = (reactFlowInstance) => {
    setReactFlowInstance(reactFlowInstance);
    setTimeout(() => reactFlowInstance.fitView(), 200);
  };

  const findAllRelations = (elRelations) => {
    let allRelations = [];
    const addRelations = (rel) => {
      let relWithRel = [];
      rel.forEach((e) => {
        allRelations.push(e);
        if (relations[e]) {
          relWithRel.push(e);
        }
      });

      if (relWithRel.length > 0) {
        relWithRel.forEach((e) => {
          if (relations[e]) {
            addRelations(relations[e]);
          }
        });
      }
    };

    addRelations(elRelations);
    return allRelations;
  };

  const setAllPositions = (nodes) => {
    const groupedByLevel = {};
    let ownData;

    nodes.forEach((n) => {
      if (n.level !== 0) {
        if (groupedByLevel[n.level]) {
          groupedByLevel[n.level].push(n);
        } else {
          groupedByLevel[n.level] = [n];
        }
      } else {
        ownData = n;
      }
    });

    const elements = [ownData];
    Object.entries(groupedByLevel).forEach(([k, v]) => {
      let group = [];
      let maxChildY = ((v.length + 1) * (Y / 2));
      if (k === '1') {
        let lirInc = 0;
        v.forEach((el, i) => {
          if (el && el.config && el.config.type === 'lir') {
            lirInc += 10;
          }
          group.push({
            ...el,
            position: {
              x: X,
              y: maxChildY - (Y * (i + 1)) + lirInc,
            }
          });
        });
      } else {
        const groupedBySource = {};
        v.forEach((el) => {
          if (groupedBySource[el.source]) {
            groupedBySource[el.source].push(el);
          } else {
            groupedBySource[el.source] = [el];
          }
        });
        const parentX = groupedByLevel[k - 1][0].position.x + 0;
        Object.values(groupedBySource).forEach((v, i) => {
          const parentY = groupedByLevel[k - 1][i].position.y + 0;
          maxChildY = ((v.length + 1) * (Y / 2)) + parentY;
          v.forEach((el, i) => {
            group.push({
              ...el,
              position: {
                x: parentX + X,
                y: maxChildY - (Y * (i + 1)),
              },
            });
          })
        });
      }

      elements.push(...group);
      groupedByLevel[k] = group;
    });

    return elements;
  };

  const toggleElement = (id, toggled) => {
    const elRelations = relations[id];
    let otherRelations = [];
    let sameLevelRelations;

    if (activeNode) {
      setActiveNode(null);
    }

    const el = initElements.find((e) => e.id === id);
    if (elRelations) {
      otherRelations = findAllRelations(elRelations);
      setInitElements((p) => {
        let elements = p;
        elements = p.map((el) => {
          if (elRelations.includes(el.id) && el.source === id) {
            return {
              ...el,
              isHidden: toggled,
              toggled: !propHasValue(el.toggled) ? undefined : false,
            };
          }

          if (el.source) {
            if (el.source === id) {
              return { ...el, isHidden: toggled };
            }
          }

          if (el.id === id) {
            return { ...el, toggled: !toggled };
          }

          if (sameLevelRelations) {
            if (sameLevelRelations.includes(el.id)) {
              return {
                ...el,
                isHidden: true,
              };
            }
          }

          if (toggled === true) {
            if (otherRelations.includes(el.id)) {
              return {
                ...el,
                isHidden: true,
                toggled: !propHasValue(el.toggled) ? undefined : false,
              };
            }
            if (el.target) {
              if (otherRelations.includes(el.target)) {
                return { ...el, isHidden: true };
              }
            }
          }
          if (el.level === 2) {
            return { ...el, isHidden: true };
          }
          if (el.level === 1) {
            return { ...el, toggled: typeof el.toggled === 'undefined' ? undefined : false };
          }
          return el;
        });
        return elements;
      });
    }


    if (reactFlowInstance && el && el.level === 1) {
      setTimeout(() =>
        reactFlowInstance.fitView(), 100);
    }
  };

  const initializeItems = (items) => {
    let nodes = [];
    let connections = {};
    const ownData = items.location;
    let lirId = 1;

    const pushChildrens = (id, childrens, parentLevel) => {
      if (childrens.length > 0) {
        let childrensWithChildrens = [];
        let parentConnections = [];

        childrens.forEach((ch, i) => {
          if (!ch) {
            return
          }
          let parentConfig;
          let childId = ch.id;
          if (ch.parentId) {
            const par = nodes.find((n) => n.id === ch.parentId);
            if (par) {
              parentConfig = par.config;
            }
          }

          if (ch.type === 'lir') {
            lirId += 1;
            childId = `LIR-${lirId}`;
          }

          nodes.push({
            id: childId,
            data: { label: ch.label || '' },
            type: 'node',
            source: id,
            config: { ...ch, parentConfig },
            isHidden: parentLevel > 0,
            toggled: (ch.childrens && ch.childrens.length > 0) ? false : undefined,
            level: parentLevel + 1,
          });

          parentConnections.push(childId);

          if (ch.childrens && ch.childrens.length) {
            childrensWithChildrens.push(ch);
          }
        });
        connections[id] = parentConnections;

        if (childrensWithChildrens.length > 0) {
          childrensWithChildrens.forEach((ch) => {
            pushChildrens(ch.id, ch.childrens, parentLevel + 1);
          });
        }
      }
    };

    if (ownData) {
      nodes.push({
        id: ownData.id,
        sourcePosition: 'left',
        position: { x: 0, y: 0 },
        type: 'node',
        toggled: ownData.childrens.length > 0 ? true : undefined,
        config: { ...ownData, type: 'ownData' },
        level: 0,
      });
      pushChildrens(ownData.id, ownData.childrens, 0);
    }

    let edges = [];
    Object.keys(connections).forEach((k) => {
      const source = k;
      const values = connections[k];
      values.forEach((val) => {
        const node = nodes.find((n) => n.id === val);
        edges.push({
          id: `${source}-${val}`,
          source,
          target: source !== (ownData || {}).id ? `${val}-${source}` : val,
          type: 'edge',
          isHidden: node.isHidden,
          level: node.level,
        });
      });
    });

    nodes = setAllPositions(nodes);

    setInitElements([
      ...nodes,
      ...edges,
    ]);
    setRelations(connections);
  };

  useEffect(() => {
    if (items && Object.keys(items.location).length) {
      initializeItems(items);
    } else {
      setInitElements([]);
      setRelations({});
    }
  }, [items]);

  useEffect(() => {
    if (initElements) {
      const filteredElements = initElements.filter((i) => !i.isHidden);
      setElements(filteredElements.map((el) => {
        switch (el.type) {
          case 'edge':
            if (el.target && el.source && el.id) {
              return {
                id: el.id,
                source: el.source,
                type: 'buttonedge',
                target: el.target,
                animated: false,
              };
            }
            return {};
          case 'node':
            return {
              id: (el.id || '').includes('STK') ? `${el.id}-${el.source}` : el.id,
              data: {
                label: (
                  <>
                    {el.config.type === 'ownData' ? (
                      <OwnDataStyle
                        className={el.toggled ? 'active' : 'un-active'}
                        onClick={() => toggleElement(el.id, el.toggled, el.level)}
                      >
                        <img src="/assets/images/dashboard/mine-site.svg" alt="Mine Site" />
                        <Tooltip title={el.config.name}>
                          <label>
                            {el.config.name}
                          </label>
                        </Tooltip>
                      </OwnDataStyle>
                    ) : (
                      <>
                        <Default
                          className={el.toggled || (activeNode || {}).id === el.id ? 'active' : 'un-active'}
                          onClick={() => toggleElement(el.id, el.toggled, el.level)}
                        >
                          {el.config.type === 'BLANK' ? (
                            <Tooltip
                              title={t('No entities found. Link an entity to see it here.')}
                            >

                              {t('No entities found. Link an entity to see it here.')}
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title={t(el.config.name)}
                            >
                              <label>
                                {t(el.config.name)}
                              </label>
                            </Tooltip>

                          )}
                        </Default>
                        {el.config.type !== 'BLANK' && el.level === 2 && (
                          <CircleStyle
                            className={`square ${(activeNode || {}).id === el.id ? 'active' : 'not-active'}`}
                          />
                        )}
                      </>
                    )}
                    {el.config.type !== 'ownData' && typeof el.toggled === 'boolean' && (
                      <CircleStyle
                        className={`square ${el.toggled ? 'active' : 'not-active'}`}
                      />
                    )}
                  </>
                ),
              },
              style: {
                background: 'transparent',
                border: 0,
                width: 'fit-content',
                height: 35,
              },
              className: formatClassname([
                'node',
                el.toggled && 'node-active',
                el.config.type === 'ownData' && 'own-data',
                (activeNode || {}).id === el.id && 'node-active last-level',
              ]),
              position: el.position,
              sourcePosition: type === 'RL' ? 'left' : 'right',
              targetPosition: type === 'RL' ? 'right' : 'left',
            };
          default:
            return null;
        }
      }));
    }
  }, [initElements, activeNode]);

  useEffect(() => {
    setActiveNode(null);
  }, [i18next.language]);

  return {
    elements,
    initElements,
    onElementsRemove,
    onConnect,
    onLoad,
  };
}

export const RenderToggelableFlow = ({
  elements = [],
  onElementsRemove = () => { },
  onConnect = () => { },
  onLoad = () => { },
  initElements = [],
  setActiveNode = () => { },
}) => (
  <ReactFlowProvider>
    <ReactFlow
      elements={elements}
      onElementsRemove={onElementsRemove}
      onConnect={onConnect}
      onLoad={onLoad}
      selectNodesOnDrag={false}
      draggable={false}
      nodesDraggable={false}
      nodesConnectable={false}
      zoomOnScroll={false}
      onElementClick={(e) => {
        if (e.target) {
          if (e.target.classList) {
            if (!e.target.classList.contains('toggle-button')) {
              const id = e.currentTarget.getAttribute('data-id');
              const node = initElements.find((el) => el.id === id || `${el.id}-${el.source}` === id);
              if (node && node.config && node.level === 2 && node.config.type !== 'BLANK') {
                setActiveNode(node.config);
              }
            }
          }
        }
      }}
    >
      <Controls
        showInteractive={false}
      />
    </ReactFlow>
  </ReactFlowProvider>
);
